export interface Language {
    code: string
    name: string
}

import data from './languages.en.json' assert { type: 'json' }
export const languagesEn = data as Language[]

export const byCode = Object.fromEntries(
    languagesEn.map(l => [l.code, l])
) as Record<string, Language>
